import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { BoomerHttpClient } from './boomer-http-client';
import { Enrollment } from 'src/app/modules/admin-features/components/enrollments/enrollments.component';
import { HttpResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentsService {
  private readonly snackBar = inject(MatSnackBar);
  enrollmentsSubject: BehaviorSubject<null> = new BehaviorSubject(null);

  constructor(private http: BoomerHttpClient) {}

  getEnrollmentsById(
    id: string,
    pageNumber = 0,
    pageSize = 15,
    completedOnly = false,
  ): Observable<{ items: Enrollment[]; totalCount: number }> {
    return this.enrollmentsSubject.pipe(
      switchMap(() =>
        this.http.get<Enrollment[]>(`/enrollment/applicant/${id}?page=${pageNumber}&pageSize=${pageSize}`, {
          observe: 'response',
        }),
      ),
      map(res => {
        const filtered = completedOnly
          ? res.body.filter(item => item.status === 'CONNECTURE_COMPLETED' || item.status === 'MANUALLY_SUBMITTED')
          : res.body;
        const totalCount = completedOnly ? filtered.length : +res.headers.get('x-total-elements');
        return { items: filtered, totalCount };
      }),
    );
  }

  downloadPdf(id: string) {
    return this.http.get(`/enrollment/${id}/pdf`, { observe: 'response', responseType: 'blob' }).pipe(
      map(res => {
        const contentType = res.headers.get('Content-Type');
        console.log(contentType);
        switch (contentType) {
          case 'application/pdf':
            const blob = new Blob([(res as HttpResponse<Blob>).body], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `enrollment-${id}.pdf`;
            link.click();
            window.URL.revokeObjectURL(url);
            break;
          case 'application/json':
            console.error(res.body);
            this.snackBar.open('Error downloading PDF', 'Dismiss', { duration: 3000 });
            break;
        }
      }),
      catchError((err: unknown) => {
        console.error(err);
        this.snackBar.open('Error downloading PDF', 'Dismiss', { duration: 3000 });
        return of(null);
      }),
    );
  }
}
